import { HomeAwayChannelConfig, HomeAwayRentalConfig } from './channels.model'
import { Dictionary } from '@ngrx/entity'
import { ChannelNameTokens } from '@tokeet-frontend/tv3-platform'
import { HoliduState } from './holidu'
import { HvmiState } from './hvmi'
import { CtripState } from './ctrip'
import { TicketState } from './tiket'
import { HopperState } from './hopper'
import { GVRState } from './gvr'
import { RentalsUnitedState } from './rentals-united'

export interface State {
  configLoaded: Dictionary<boolean>
  rentalConfigs: Dictionary<HomeAwayRentalConfig[]>
  configs: Dictionary<HomeAwayChannelConfig>
  hvmi: HvmiState
  rentalUnited: RentalsUnitedState
  holidu: HoliduState
  gvr: GVRState
  hopper: HopperState
  ctrip: CtripState
  tiket: TicketState
}

export const initialState: State = {
  configLoaded: {
    [ChannelNameTokens.Homeaway]: false,
  },
  configs: {},
  rentalConfigs: {},
  hvmi: {
    status: null,
    listings: [],
    validations: {},
    validationsLoaded: false,
  },
  rentalUnited: {
    status: null,
    listings: [],
    validations: null,
    validationsLoaded: false,
  },
  holidu: {
    status: null,
    listings: [],
    validations: {},
    validationsLoaded: false,
  },
  gvr: {
    status: null,
    listings: [],
    validations: {},
    validationsLoaded: false,
  },
  tiket: {
    status: null,
    listings: [],
  },
  ctrip: {
    status: null,
    listings: [],
  },
  hopper: {
    status: null,
    listings: [],
    validations: {},
    validationsLoaded: false,
  },
}
